import { render, staticRenderFns } from "./DashboardToolbar.vue?vue&type=template&id=2356954e&scoped=true"
import script from "./DashboardToolbar.vue?vue&type=script&lang=js"
export * from "./DashboardToolbar.vue?vue&type=script&lang=js"
import style0 from "./DashboardToolbar.vue?vue&type=style&index=0&id=2356954e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356954e",
  null
  
)

export default component.exports